import _defineProperty from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["active", "fontFamily", "textStyle", "fontSize", "fontSizeMobile", "style", "icon", "text", "noBorder", "borderRadiusValue", "color", "type", "borderRadiusType", "textType", "heightButton", "width", "className", "blockMobileScale"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default from 'react';
import styled, { css } from 'styled-components';
import PropTypes from '../../node_modules/prop-types/index.js';
import Text from '../text/text.component.js';
import { genericButtonStyle, backgroundColorButtonHover, borderButtonNoBorderHover, textColorButtonHover, textColorButton, fontSizeTextButton, lineHeightTextButton, heightButtonMobile } from '../../theme/button-theme.js';
import { BUTTON_PROPTYPES } from '../../constants/proptypes.js';

/* TODO -> Usare i temi */

var ButtonWrapper = styled.button.withConfig({
  displayName: "button-submitcomponent__ButtonWrapper",
  componentId: "sc-1cm3qx2-0"
})(["", ";width:", ";", ";display:flex;align-items:center;justify-content:center;box-sizing:border-box;cursor:", ";pointer-events:", ";.icon-btn{transition:0.2s;transform:translateX(0px);}", " &:hover{", ";", ";& > p,& > a > p{", ";}.icon-btn{transition:0.2s;transform:translateX(4px);}}& > p,& > a > p,& > linkcomponent > p{", ";", ";", ";}@media screen and (max-width:768px){", " ", " & > p,& > a > p,& > linkcomponent > p{font-size:", ";", ";}}", ""], genericButtonStyle, function (props) {
  return props.width;
}, function (props) {
  return props.borderRadiusValue ? "border-radius: " + props.borderRadiusValue : "";
}, function (props) {
  return props.active === "true" ? "pointer" : "auto";
}, function (props) {
  return props.active === "true" ? "" : "none";
}, function (props) {
  return props.active ? css(["&:active{transition:transform 0.1s ease-in-out;transform:scale(0.95);}"]) : "";
}, backgroundColorButtonHover, borderButtonNoBorderHover, textColorButtonHover, textColorButton, function (props) {
  return props.fontSize ? "font-size: " + props.fontSize : fontSizeTextButton;
}, lineHeightTextButton, function (props) {
  return props.blockMobileScale ? "" : css(["", ";"], heightButtonMobile);
}, function (props) {
  return props.blockMobileScale ? "" : css(["", ";"], heightButtonMobile);
}, function (props) {
  return props.fontSizeMobile ? "font-size: " + props.fontSizeMobile : fontSizeTextButton;
}, lineHeightTextButton, genericButtonStyle);
ButtonWrapper.propTypes = {
  color: PropTypes.oneOf(BUTTON_PROPTYPES.colors_list),
  type: PropTypes.oneOf(BUTTON_PROPTYPES.types_list),
  textType: PropTypes.oneOf(BUTTON_PROPTYPES.text_types_list),
  active: PropTypes.oneOf(BUTTON_PROPTYPES.active_list),
  borderRadiusType: PropTypes.oneOf(BUTTON_PROPTYPES.border_radius_types_list),
  noBorder: PropTypes.oneOf(BUTTON_PROPTYPES.no_borders_list),
  heightButton: PropTypes.oneOf(BUTTON_PROPTYPES.heights_list)
};
ButtonWrapper.defaultProps = {
  color: "green",
  type: "primary",
  textType: "medium",
  active: "true",
  borderRadiusType: "smallRounded",
  noBorder: "false",
  heightButton: "medium",
  fontFamily: "graphik",
  blockMobileScale: false
};
/**
 * @deprecated
 */

var ButtonSubmit = function ButtonSubmit(_ref) {
  var active = _ref.active,
    fontFamily = _ref.fontFamily,
    textStyle = _ref.textStyle,
    fontSize = _ref.fontSize,
    fontSizeMobile = _ref.fontSizeMobile,
    style = _ref.style,
    icon = _ref.icon,
    text = _ref.text,
    noBorder = _ref.noBorder,
    borderRadiusValue = _ref.borderRadiusValue,
    color = _ref.color,
    type = _ref.type,
    borderRadiusType = _ref.borderRadiusType,
    textType = _ref.textType,
    heightButton = _ref.heightButton,
    width = _ref.width,
    className = _ref.className,
    blockMobileScale = _ref.blockMobileScale,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    className: className,
    type: type,
    color: color,
    noBorder: noBorder,
    textType: textType,
    fontSize: fontSize,
    fontSizeMobile: fontSizeMobile,
    borderRadiusValue: borderRadiusValue,
    borderRadiusType: borderRadiusType,
    active: active,
    style: style,
    heightButton: heightButton,
    blockMobileScale: blockMobileScale,
    width: width ? width : "auto"
  }, text ? /*#__PURE__*/React__default.createElement(Text, {
    type: "label",
    fontFamily: fontFamily,
    fontSize: "small",
    style: _objectSpread({
      transition: "0.2s"
    }, textStyle)
  }, text) : rest.children ? rest.children : null);
};
export { ButtonSubmit as default };